// iter586 — „Жив организъм" статус ред: фин пулс + час на последна синхронизация.
// iter588 — микро-сигнал какво се промени при опресняването („+1 хранене · DIL 63.5→71.2"),
// за да вижда пациентът как дигиталният му близнак реагира в реално време.
import React, { useState, useEffect } from "react";

export default function LivePulse({ lastSyncAt, change, isDark, bg }) {
  const [showChange, setShowChange] = useState(false);

  useEffect(() => {
    if (!change?.text) return;
    setShowChange(true);
    const t = setTimeout(() => setShowChange(false), 12000);
    return () => clearTimeout(t);
  }, [change]);

  if (!lastSyncAt) return null;
  const time = lastSyncAt.toLocaleTimeString(bg ? "bg-BG" : [], { hour: "2-digit", minute: "2-digit", hour12: false });
  return (
    <div className="flex justify-end items-center gap-2 -mb-2" data-testid="cc-live-pulse">
      {showChange && change?.text && (
        <span
          className={`inline-flex items-center gap-1 text-[11px] font-semibold px-2.5 py-0.5 rounded-full ${
            isDark ? "bg-emerald-500/15 text-emerald-300" : "bg-emerald-50 text-emerald-700"
          }`}
          style={{ animation: "fadeIn 0.5s ease" }}
          data-testid="cc-live-change"
        >
          ↻ {change.text}
        </span>
      )}
      <span className={`inline-flex items-center gap-1.5 text-[11px] font-medium ${isDark ? "text-gray-500" : "text-gray-400"}`}>
        <span className="relative flex h-2 w-2" aria-hidden="true">
          <span
            className="absolute inline-flex h-full w-full rounded-full bg-emerald-400"
            style={{ animation: "live-pulse-glow 3.5s ease-in-out infinite" }}
          />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
        </span>
        {bg ? `Жив метаболитен образ · обновен в ${time}` : `Live metabolic twin · synced at ${time}`}
      </span>
    </div>
  );
}
